<template lang="html">
  <v-container fluid style="position: absolute">
    <v-row>
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col cols="10" xs10>
              <StandardTextfield
                color="secondary"
                icon="search"
                textcolor="white"
                placeholder="Search for hashtags"
                :value="hashtags"
                @changeValue="hashtags = $event"
                style="width: 90%"
              />
            </v-col>
            <v-col cols="2" xs2>
              <v-btn color="secondary" @click="search({hashtags: hashtags})">
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getCommunityWorkSteps.length === 0" align="center" justify="center">
      <v-col cols="10" align="center" justify="center">
        <v-alert type="info">
          There are no Work Steps in the community yet.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col :cols="getCols()" v-for="community_work_step in getCommunityWorkSteps" :key="community_work_step.id">
              <v-card class="color-3 pa-2">
                <v-row>
                  <v-col cols="12">
                    <WorkStepHeaderDetails @hashtagSearchClick="search($event)" :work_step="community_work_step" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    {{community_work_step.text}}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="10" xs10>
                    <CommunityOwnerDetails :owner="community_work_step.owner" />
                  </v-col>
                  <v-col cols="2" xs2>
                    <StandardLikeBtn class="pull-right" :el="community_work_step" :curr_user_id="getUserId" @unlikeClick="unlikeCStep($event)" @likeClick="likeCStep($event)" />
                    <StandardDeleteBtn v-if="hasPermission('CWorkStep DELETE')" :el="community_work_step" btnclass="pull-right" @deleteClick="deleteCWorkStep($event)" />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store/index';
import {
  mapGetters,
  mapActions
} from 'vuex';
import WorkStepHeaderDetails from '@/components/WorkSteps/WorkStepHeaderDetails.component.vue';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import StandardLikeBtn from '@/components/StandardComponents/StandardLikeBtn.component.vue';
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import CommunityOwnerDetails from '@/components/Community/CommunityOwnerDetails.component.vue';
export default {
  name: 'CommunityWorkSteps',
  components: {
    WorkStepHeaderDetails,
    StandardTextfield,
    StandardLikeBtn,
    StandardDeleteBtn,
    CommunityOwnerDetails
  },
  data: function() {
    return {
      hashtags: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('Community/requestCWorkSteps').then(res => next(res));
  },
  computed: {
    ...mapGetters('Community', [
      'getCommunityWorkSteps',
      'isLoading'
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
      'getUserId'
    ])
  },
  methods: {
    ...mapActions('Community', [
      'deleteCommunityWorkStep',
      'likeCommunityWorkStep',
      'unlikeCommunityWorkStep',
      'requestCommunityWorkStepsByHashtags',
      'requestCWorkSteps'
    ]),
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    },
    deleteCWorkStep(cwork_step){
      this.deleteCommunityWorkStep({
        cworkstep_id: cwork_step.id
      });
    },
    unlikeCStep(cwork_step){
      this.unlikeCommunityWorkStep({
        cworkstep_id: cwork_step.id
      });
    },
    likeCStep(cwork_step){
      this.likeCommunityWorkStep({
        cworkstep_id: cwork_step.id
      });
    },
    search: function (payload) {
      this.hashtags = payload.hashtags;
      if (payload.hashtags.length) {
        this.requestCommunityWorkStepsByHashtags(payload);
      }
      else {
        this.requestCWorkSteps();
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
